import React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import LocaleSwitcher from './LocaleSwitcher';

const CustomAppBar = (props) => (
	<AppBar {...props}>
		<Typography
			color="inherit"
			className="title"
			id="react-admin-title"
		/>
		<span className="spacer" style={{ marginLeft: 'auto' }}/>
		<LocaleSwitcher/>
	</AppBar>);

export default CustomAppBar;
